import { Injectable, Input, EventEmitter } from "@angular/core";
import { BaseService } from "./BaseService";
import { APIServiceConnector } from "./APIServiceConnector";
import { AppSettings } from "../Library/AppSettings";
import { SimpleResponse, ListResponse } from "../Models/ResponseModels";
import { MasterDataService } from "./MasterDataService";
import { Device_UpdateRequest } from "../Models/RequestModels";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class DeviceService extends BaseService {

    ActivationProgress = new EventEmitter();
    constructor(
        public apiService: APIServiceConnector,
        public masterService: MasterDataService,
        public cookieService: CookieService,
    ) {
        super();
    }

    Device_Search(req:any): Promise<ListResponse> {
        return this.apiService
            .postAPI(AppSettings.URL_Session , "Authentication/GetAllUsersIdentifierToken",req,false)
            .then(data => {
                if (data && !data.HasError) {
                }
                return data;
            });
    }

    Device_Update(req: Device_UpdateRequest): Promise<ListResponse> {
        return this.apiService
        .postAPI(AppSettings.URL_Session, "Authentication/UpdateWebSessionIDsStatus", req ,false)
        .then(data => {
            if (data && !data.HasError) {
            }

            return data;
        });
    }

    Deactivate_Devices(req) : Promise<ListResponse> {
        return this.apiService
        .postAPI(AppSettings.URL_Session, "Authentication/DeActivateAllUsersIdentifierToken",req,false)
        .then(data => {
            if (data && !data.HasError) {
            }
            return data;
        });
    }

    DeviceDeactivationProgress(data){
        this.ActivationProgress.emit(data);
    }
}
